import { API_URL, API_KEY, RESULTS_PER_PAGE } from './config.js';
import { AJAX } from './helpers.js';

import { async } from 'regenerator-runtime';

export const state = {
  recipe: {},
  search: {
    query: '',
    page: 1,
    results: [],
    resultsPerPage: RESULTS_PER_PAGE,
  },
  bookmarks: [],
};

const createRecipeObject = data => {
  const recipe = data.data.recipe;

  return {
    id: recipe.id,
    title: recipe.title,
    image: recipe.image_url,
    servings: recipe.servings,
    publisher: recipe.publisher,
    sourceUrl: recipe.source_url,
    ingredients: recipe.ingredients,
    cookingTime: recipe.cooking_time,
    ...(recipe.key && { key: recipe.key }),
  };
};

export const loadRecipe = async id => {
  try {
    const data = await AJAX(`${API_URL}${id}?key=${API_KEY}`);
    state.recipe = createRecipeObject(data);

    state.recipe.bookmarked = state.bookmarks.some(
      bookmark => bookmark.id === id
    )
      ? true
      : false;
  } catch (err) {
    throw err;
  }
};

export const updateServings = newServings => {
  state.recipe.ingredients.forEach(
    ing => (ing.quantity = (ing.quantity / state.recipe.servings) * newServings)
  );
  state.recipe.servings = newServings;
};

export const uploadRecipe = async recipe => {
  try {
    const ingredients = Object.entries(recipe)
      .filter(entry => entry[0].startsWith('ingredient') && entry[1].trim())
      .map(ing => {
        const ingredientArray = ing[1].split(',').map(el => el.trim());

        if (ingredientArray.length !== 3)
          throw Error(
            'Wrongly formatted ingredients. Please use the correct format...'
          );

        const [quantity, unit, description] = ingredientArray;

        return {
          quantity: +quantity || null,
          unit,
          description,
        };
      });

    const newRecipe = {
      title: recipe.title,
      image_url: recipe.image,
      ingredients: ingredients,
      servings: +recipe.servings,
      publisher: recipe.publisher,
      source_url: recipe.sourceUrl,
      cooking_time: +recipe.cookingTime,
    };

    const data = await AJAX(`${API_URL}?key=${API_KEY}`, newRecipe);
    state.recipe = createRecipeObject(data);

    addBookmark();
  } catch (err) {
    throw err;
  }
};

export const loadSearchResults = async query => {
  try {
    state.search.query = query;

    const {
      data: { recipes },
    } = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`);

    state.search.results = recipes.map(recipe => {
      return {
        id: recipe.id,
        title: recipe.title,
        image: recipe.image_url,
        publisher: recipe.publisher,
        ...(recipe.key && { key: recipe.key }),
      };
    });
  } catch (err) {
    throw err;
  }
};

export const getSearchResultsPage = (page = state.search.page) => {
  const start = (page - 1) * state.search.resultsPerPage;
  const end = page * state.search.resultsPerPage;

  state.search.page = page;
  return state.search.results.slice(start, end);
};

export const addBookmark = (recipe = state.recipe) => {
  state.recipe.bookmarked = true;
  state.bookmarks.push(recipe);
  persistBookmarks();
};
export const removeBookmark = (id = state.recipe.id) => {
  state.recipe.bookmarked = false;
  const index = state.bookmarks.findIndex(bookmark => bookmark.id === id);
  state.bookmarks.splice(index, 1);
  persistBookmarks();
};

const persistBookmarks = () => {
  try {
    localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
  } catch (err) {
    console.error(err.message);
  }
};

const init = () => {
  if (!localStorage?.bookmarks) return;
  state.bookmarks = JSON.parse(localStorage.bookmarks);
};

init();
